module.exports = __webpack_public_path__ + "static/img/homeBg.066568d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/homeBg.png
// module id = okBO
// module chunks = 1